import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserRootState, UsersApi } from "..";
import { BackendInterface } from "../../core";

const fetchLoggedInUser = createAsyncThunk(
  "user/fetchLoggedInUser",
  async (backend: BackendInterface) => {
    return await UsersApi.getLoggedInUser(backend);
  },
);

const loginUser = createAsyncThunk(
  "user/loginUser",
  async (
    args: {
      backend: BackendInterface;
      email: string;
      password: string;
      rememberMe: boolean;
    },
    { rejectWithValue },
  ) => {
    const { backend, email, password, rememberMe } = args;
    const response = await UsersApi.logIn(backend, email, password, rememberMe);
    if (response.errorMessage) {
      return rejectWithValue(response.errorMessage);
    }
    return response;
  },
);

const postUsedFeatures = createAsyncThunk(
  "users/postUsedFeatured",
  async (backend: BackendInterface, thunkApi) => {
    const state: UserRootState = thunkApi.getState() as UserRootState;
    if (state.user.user === null) return [];
    if (state.user.user.id < 1) return [];
    const response = await UsersApi.postUsedFeatures(
      backend,
      state.user.user.id,
      state.user.usedFeatures,
    );
    if (!response.success) {
      return state.user.usedFeatures;
    }
    return [];
  },
);

export const UserThunks = {
  fetchLoggedInUser,
  loginUser,
  postUsedFeatures,
};
